module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "part",
      "title": "PART 1"
    }
  }, [_c('header', [_c('p', {
    staticClass: "h2-p",
    attrs: {
      "id": "pa1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2-p1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_vm._v("AMERICAN BORN, BICULTURAL BRED")])])]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("昔の剣今の菜刀")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('i', [_vm._v("Mukashi no tsurugi ima no na-gatana")])]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("Fortune is made of glass.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e2f224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062351951_Part_1.vue
// module id = 78
// module chunks = 0